import { render, staticRenderFns } from "./ListApproval.vue?vue&type=template&id=9ea1e60e"
import script from "./ListApproval.vue?vue&type=script&lang=js"
export * from "./ListApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports